import { NgModule } from '@angular/core';
import { AsyncLabelPipe } from './async-label.pipe';



@NgModule({
  declarations: [AsyncLabelPipe],
  exports: [AsyncLabelPipe]
})
export class AsyncLabelModule { }
